import type { paymentsApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSService } from "../../../../utils/WSService";

const service = new WSService("/v2/payments/currency");

export const getCurrencyRate = async (
  requestBody: paymentsApiSpec.operations["getCurrencyQuote"]["requestBody"]["content"]["application/json"]
): Promise<
  paymentsApiSpec.operations["getCurrencyQuote"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.post("/quotes", requestBody);

  return data;
};
